module.exports = __webpack_public_path__ + "static/media/about-partner-carousel-1.5829c6e9.png";